var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6377_15986)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7083 15.7069C12.5208 15.8943 12.2665 15.9996 12.0013 15.9996C11.7362 15.9996 11.4818 15.8943 11.2943 15.7069L5.63732 10.0499C5.54181 9.95761 5.46563 9.84726 5.41322 9.72526C5.36081 9.60326 5.33322 9.47204 5.33207 9.33926C5.33092 9.20648 5.35622 9.0748 5.4065 8.9519C5.45678 8.829 5.53103 8.71735 5.62492 8.62346C5.71882 8.52957 5.83047 8.45531 5.95337 8.40503C6.07626 8.35475 6.20794 8.32945 6.34072 8.3306C6.4735 8.33176 6.60472 8.35934 6.72672 8.41175C6.84873 8.46416 6.95907 8.54034 7.05132 8.63585L12.0013 13.5859L16.9513 8.63585C17.1399 8.4537 17.3925 8.3529 17.6547 8.35518C17.9169 8.35746 18.1677 8.46263 18.3531 8.64804C18.5385 8.83344 18.6437 9.08426 18.646 9.34645C18.6483 9.60865 18.5475 9.86125 18.3653 10.0499L12.7083 15.7069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6377_15986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowIcon);
export default __webpack_public_path__ + "static/media/dropdown-arrow-icon.26f5dcab6c132683bf484b4e23c460a1.svg";
export { ForwardRef as ReactComponent };